// src/components/ErrorAlert.tsx
import React from "react";
import { Container, Alert } from "react-bootstrap";

interface ErrorAlertProps {
  message: string;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ message }) => (
  <Container className="py-4">
    <Alert variant="danger">Error loading data: {message}</Alert>
  </Container>
);